<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <el-input @keyup.enter.native="handleFilter" size="small" style="width: 200px;" class="filter-item"
          :placeholder="'名称'" v-model="listQuery.key"> </el-input>
        <el-date-picker v-model="listQuery.year" type="year" size="small" style="width: 120px;" class="filter-item"
          placeholder="选择年份" value-format="yyyy">
        </el-date-picker>
        <el-date-picker v-model="listQuery.month" type="month" size="small" style="width: 140px;" class="filter-item"
          placeholder="选择月份" value-format="yyyy-MM">
        </el-date-picker>
        <el-button class="filter-item" size="small" v-waves icon="el-icon-search" @click="handleFilter">搜索</el-button>
        <el-button class="filter-item" size="small" v-waves icon="el-icon-refresh" @click="resetFilter">重置</el-button>
        <el-button class="filter-item" size="small" type="primary" icon="el-icon-download"
          @click="exportExcel">导出Excel</el-button>
        <permission-btn size="small" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <div class="bg-white" style="height: 100%;">
        <auth-table style="height:calc(100% - 60px)" ref="mainTable" :select-type="'checkbox'"
          :table-fields="headerList" :data="list" :v-loading="listLoading" @row-dblclick="onBtnClicked('btnEdit')"
          @row-click="rowClick" @selection-change="handleSelectionChange" :enable-sorting="true"
          :enable-custom-filter="true" @sort-change="handleSortChange" @filter-change="handleFilterChange"></auth-table>
        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
          @pagination="handleCurrentChange" />
      </div>
      <el-dialog v-el-drag-dialog class="dialog-mini" width="500px" :title="textMap[dialogStatus]"
        :visible.sync="dialogFormVisible" v-loading="generating" element-loading-text="正在生成折旧数据，请稍候...">
        <el-form :model="temp" :rules="rules" ref="dataForm" label-width="100px">
          <el-form-item label="生成月份" prop="depreciationMonth">
            <el-date-picker v-model="temp.depreciationMonth" type="month" placeholder="请选择月份" value-format="yyyy-MM"
              style="width: 100%" :readonly="hasExistingData">
            </el-date-picker>
          </el-form-item>
          <div v-if="hasExistingData" style="color: #409EFF; font-size: 12px; margin-bottom: 10px;">
            <i class="el-icon-info"></i>
            提示：系统自动选择下一个月份进行折旧生成，确保按顺序连续生成。
          </div>
          <div v-else style="color: #67C23A; font-size: 12px; margin-bottom: 10px;">
            <i class="el-icon-info"></i>
            提示：首次生成折旧数据，可以自由选择起始月份。
          </div>
        </el-form>
        <div slot="footer">
          <el-button size="small" @click="dialogFormVisible = false" :disabled="generating">取消</el-button>
          <el-button size="small" v-if="dialogStatus == 'create'" type="primary" @click="createData"
            :disabled="generating">确认</el-button>
          <el-button size="small" v-else type="primary" @click="updateData" :disabled="generating">确认</el-button>
        </div>
      </el-dialog>

      <!-- 删除年月选择对话框 -->
      <el-dialog v-el-drag-dialog class="dialog-mini" width="450px" title="删除折旧数据" :visible.sync="deleteDialogVisible">
        <el-form :model="deleteForm" :rules="deleteRules" ref="deleteForm" label-width="100px">
          <el-form-item label="删除年月" prop="yearMonth">
            <el-date-picker v-model="deleteForm.yearMonth" type="month" placeholder="请选择要删除的年月" value-format="yyyy-MM"
              style="width: 100%" :readonly="true">
            </el-date-picker>
          </el-form-item>
          <div style="color: #409EFF; font-size: 12px; margin-bottom: 10px;">
            <i class="el-icon-info"></i>
            提示：系统自动选择当前最新月份的数据进行删除，确保按时间倒序删除。
          </div>
          <div style="color: #f56c6c; font-size: 12px; margin-top: 10px;">
            <i class="el-icon-warning"></i>
            警告：删除指定年月的折旧数据将会恢复资产状态到删除前，此操作不可撤销！
          </div>
        </el-form>
        <div slot="footer">
          <el-button size="small" @click="deleteDialogVisible = false">取消</el-button>
          <el-button size="small" type="danger" @click="confirmDelete">确认删除</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import * as assetDepreciations from '@/api/basic/assetDepreciations'
import waves from '@/directive/waves' // 水波纹指令
import Sticky from '@/components/Sticky'
import permissionBtn from '@/components/PermissionBtn'
import Pagination from '@/components/Pagination'
import elDragDialog from '@/directive/el-dragDialog'
import { defaultVal } from '@/utils/index'
import extend from '@/extensions/common.js'
import AuthTable from '../../../components/Base/AuthTable.vue'
import ColumnDefine from '@/interface/columnDefine'
import * as XLSX from 'xlsx'

export default {
  name: 'assetDepreciation',
  components: { Sticky, permissionBtn, Pagination, AuthTable },
  directives: {
    waves,
    elDragDialog,
  },
  mixins: [extend],
  data() {
    return {
      headerList: [], // 主列表列定义
      multipleSelection: [], // 列表checkbox选中的值
      tableKey: 0,
      list: null,
      filteredList: null, // 过滤后的列表数据
      total: 0,
      listLoading: true,
      listQuery: {
        // 查询条件
        page: 1,
        limit: 100,
        key: undefined,
        year: undefined,
        month: undefined,
      },
      temp: {},
      dialogFormVisible: false,
      dialogStatus: '',
      generating: false, // 生成折旧数据的加载状态
      textMap: {
        update: '编辑',
        create: '添加',
      },
      rules: {
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
      },
      deleteDialogVisible: false,
      deleteForm: {
        yearMonth: ''
      },
      deleteRules: {
        yearMonth: [{ required: true, message: '请选择要删除的年月', trigger: 'blur' }],
      },
    }
  },
  computed: {
    hasExistingData() {
      return this.list && this.list.length > 0
    }
  },
  created() {
    this.headerList = [

      new ColumnDefine('depreciationYearMonth', '折旧年月', true, true, '', '', 'int', 'int', 'DepreciationYearMonth', '80'),
      new ColumnDefine('useDepartment', '使用部门', true, true, '', '', 'string', 'varchar', 'UseDepartment', '180'),
      new ColumnDefine('assetCode', '资产编号', true, true, '', '', 'string', 'varchar', 'AssetCode', '150'),
      new ColumnDefine('assetName', '资产名称', true, true, '', '', 'string', 'varchar', 'AssetName', '200'),
      new ColumnDefine('serviceLife', '使用年限', true, true, '', '', 'int', 'int', 'ServiceLife', '100'),
      new ColumnDefine('purchaseAmount', '原值', true, true, '', '', 'decimal', 'decimal', 'PurchaseAmount', '100'),
      new ColumnDefine('estimatedResidualValue', '资产残值', true, true, '', '', 'decimal', 'decimal', 'EstimatedResidualValue', '100'),
      new ColumnDefine('monthlyDepreciation', '月折旧额', true, true, '', '', 'decimal', 'decimal', 'MonthlyDepreciation', '100'),
      new ColumnDefine('monthDep', '本月折旧', true, true, '', '', 'DateTime', 'datetime', 'MonthDep', '100'),
      new ColumnDefine('accDepBefore', '折旧前累计', true, true, '', '', 'DateTime', 'datetime', 'AccDepBefore', '100'),
      new ColumnDefine('netValBefore', '折旧前净值', true, true, '', '', 'DateTime', 'datetime', 'NetValBefore', '100'),
      new ColumnDefine('depDate', '折旧日期', true, true, '', '', 'DateTime', 'datetime', 'DepDate', '100'),
      new ColumnDefine('depYearMonth', '折旧年月', true, true, '', '', 'DateTime', 'datetime', 'DepYearMonth', '100'),
      new ColumnDefine('depreciationDate', '折旧日期', true, true, '', '', 'DateTime', 'datetime', 'DepreciationDate', '100'),


    ]
    this.getList()
  },
  methods: {

    rowClick(row) {
      this.$refs.mainTable.clearSelection()
      this.$refs.mainTable.toggleRowSelection(row)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    onBtnClicked: function (domId, callback) {
      console.log('you click:' + domId)
      switch (domId) {
        case 'btnAdd':
          this.handleCreate()
          break
        case 'btnEdit':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '只能选中一个进行编辑',
              type: 'error',
            })
            return
          }
          this.handleUpdate(this.multipleSelection[0])
          break
        case 'btnDel':
          this.handleDelete()
          break
        case 'btnExport':
          this.$refs.mainTable.exportExcel('资源文件', callback)
          break
        default:
          break
      }
    },
    getList() {
      this.listLoading = true
      assetDepreciations.getList(this.listQuery).then((response) => {
        this.list = response.data
        this.total = response.count
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val.page
      this.listQuery.limit = val.limit
      this.getList()
    },
    handleModifyStatus(row, disable) {
      // 模拟修改状态
      this.$message({
        message: '操作成功',
        type: 'success',
      })
      row.disable = disable
    },
    resetTemp() {
      let obj = {};
      this.headerList.forEach((item) => {
        obj[item.columnName] = defaultVal(item.entityType)
      })
      // 手动添加表单需要的字段
      obj.depreciationMonth = ''
      this.temp = Object.assign({}, obj) // copy obj
    },
    handleCreate() {
      // 检查是否有现有数据
      const hasData = this.list && this.list.length > 0

      // 弹出添加框
      this.resetTemp()

      if (hasData) {
        // 如果有数据，自动设置下一个月份
        const nextMonth = this.getNextGenerateMonth()
        if (!nextMonth) {
          this.$message({
            message: '无法确定下一个生成月份，请检查数据',
            type: 'warning'
          })
          return
        }
        this.temp.depreciationMonth = nextMonth
      } else {
        // 如果没有数据，用户可以自由选择，默认设置为当前月份
        const now = new Date()
        const year = now.getFullYear()
        const month = (now.getMonth() + 1).toString().padStart(2, '0')
        this.temp.depreciationMonth = `${year}-${month}`
      }

      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },

    // 获取下一个应该生成的月份（仅在有数据时使用）
    getNextGenerateMonth() {
      if (!this.list || this.list.length === 0) {
        // 如果没有数据，返回null，让调用者决定如何处理
        return null
      }

      // 找到最大的折旧年月
      const maxYearMonth = Math.max(...this.list.map(item => item.depreciationYearMonth))

      // 转换为 yyyy-MM 格式
      const yearMonthStr = maxYearMonth.toString()
      const year = parseInt(yearMonthStr.substring(0, 4))
      const month = parseInt(yearMonthStr.substring(4, 6))

      // 计算下一个月
      let nextYear = year
      let nextMonth = month + 1

      if (nextMonth > 12) {
        nextYear = year + 1
        nextMonth = 1
      }

      return `${nextYear}-${nextMonth.toString().padStart(2, '0')}`
    },
    createData() {
      // 保存提交
      this.$refs['dataForm'].validate(() => {
        // 只有在有现有数据时才验证生成的月份是否正确
        if (this.hasExistingData) {
          const expectedMonth = this.getNextGenerateMonth()
          if (this.temp.depreciationMonth !== expectedMonth) {
            this.$message({
              message: `只能生成 ${expectedMonth} 的折旧数据！不能跳月生成。`,
              type: 'error'
            })
            return
          }
        }

        // 防止重复点击
        if (this.generating) return

        this.generating = true // 开始生成，显示loading
        assetDepreciations.add(this.temp).then(() => {
          this.list.unshift(this.temp)
          this.dialogFormVisible = false
          this.$notify({
            title: '成功',
            message: '创建成功',
            type: 'success',
            duration: 2000,
          })
          this.getList()
        }).catch((error) => {
          this.$message({
            message: '生成失败：' + (error.message || '未知错误'),
            type: 'error'
          })
        }).finally(() => {
          this.generating = false // 完成后隐藏loading
        })
      })
    },
    handleUpdate(row) {
      // 弹出编辑框
      this.temp = Object.assign({}, row) // copy obj
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    updateData() {
      // 更新提交
      this.$refs['dataForm'].validate(() => {
        const tempData = Object.assign({}, this.temp)
        assetDepreciations.update(tempData).then(() => {
          for (const v of this.list) {
            if (v.id === this.temp.id) {
              const index = this.list.indexOf(v)
              this.list.splice(index, 1, this.temp)
              break
            }
          }
          this.dialogFormVisible = false
          this.$notify({
            title: '成功',
            message: '更新成功',
            type: 'success',
            duration: 2000,
          })
        })
      })
    },
    handleDelete() {
      // 获取当前数据中的最大年月
      const maxYearMonth = this.getMaxYearMonth()
      if (!maxYearMonth) {
        this.$message({
          message: '暂无折旧数据可删除',
          type: 'warning'
        })
        return
      }

      // 打开删除年月选择对话框，并设置默认值为最大年月
      this.deleteForm.yearMonth = maxYearMonth
      this.deleteDialogVisible = true
      this.$nextTick(() => {
        this.$refs['deleteForm'].clearValidate()
      })
    },

    // 获取当前数据中的最大年月
    getMaxYearMonth() {
      if (!this.list || this.list.length === 0) {
        return null
      }

      // 找到最大的折旧年月
      const maxYearMonth = Math.max(...this.list.map(item => item.depreciationYearMonth))

      // 转换为 yyyy-MM 格式
      const yearMonthStr = maxYearMonth.toString()
      const year = yearMonthStr.substring(0, 4)
      const month = yearMonthStr.substring(4, 6)

      return `${year}-${month}`
    },

    confirmDelete() {
      // 确认删除指定年月的折旧数据
      this.$refs['deleteForm'].validate((valid) => {
        if (valid) {
          // 验证是否为最大年月
          const maxYearMonth = this.getMaxYearMonth()
          if (this.deleteForm.yearMonth !== maxYearMonth) {
            this.$message({
              message: `只能删除最新月份的数据！当前最新月份是：${maxYearMonth}`,
              type: 'error'
            })
            return
          }

          // 将年月格式从 yyyy-MM 转换为 yyyyMM (如 202509)
          const yearMonth = this.deleteForm.yearMonth.replace('-', '')
          const yearMonthInt = parseInt(yearMonth)

          this.$confirm(`确认删除 ${this.deleteForm.yearMonth} 的所有折旧数据吗？此操作将恢复资产状态到删除前，不可撤销！`, '警告', {
            confirmButtonText: '确认删除',
            cancelButtonText: '取消',
            type: 'warning',
            dangerouslyUseHTMLString: false
          }).then(() => {
            assetDepreciations.deleteByYearMonth(yearMonthInt).then(() => {
              this.deleteDialogVisible = false
              this.$notify({
                title: '成功',
                message: '删除成功',
                type: 'success',
                duration: 2000,
              })
              this.getList() // 重新加载列表
            }).catch((error) => {
              this.$message({
                message: error.message || '删除失败',
                type: 'error'
              })
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
        }
      })
    },
    resetFilter() {
      this.listQuery.page = 1
      this.listQuery.key = undefined
      this.listQuery.year = undefined
      this.listQuery.month = undefined
      this.getList()
    },
    // 处理表格排序
    handleSortChange({ prop, order }) {
      if (!prop || !order) return;

      const data = this.filteredList || this.list;
      const sortedData = [...data];

      sortedData.sort((a, b) => {
        let valueA = a[prop];
        let valueB = b[prop];

        // 处理数字类型
        if (!isNaN(Number(valueA)) && !isNaN(Number(valueB))) {
          valueA = Number(valueA);
          valueB = Number(valueB);
        }

        // 处理日期类型
        if (valueA && valueB && !isNaN(Date.parse(valueA)) && !isNaN(Date.parse(valueB))) {
          valueA = new Date(valueA);
          valueB = new Date(valueB);
        }

        // 按照顺序排序
        if (order === 'ascending') {
          return valueA > valueB ? 1 : -1;
        } else {
          return valueA < valueB ? 1 : -1;
        }
      });

      this.list = sortedData;
    },

    // 处理表格筛选
    handleFilterChange(filteredData) {
      this.filteredList = filteredData;
      this.list = filteredData;
      this.total = filteredData.length;
    },
    exportExcel() {
      // 创建一个工作簿
      const wb = XLSX.utils.book_new()

      // 准备数据
      const data = this.list.map(item => {
        const row = {}
        // 按照headerList的顺序生成Excel表头和数据
        this.headerList.forEach(header => {
          row[header.remark] = item[header.columnName]
        })
        return row
      })

      // 创建工作表
      const ws = XLSX.utils.json_to_sheet(data)

      // 将工作表添加到工作簿
      XLSX.utils.book_append_sheet(wb, ws, '资产折旧表')

      // 生成文件名
      const fileName = `资产折旧表_${new Date().toISOString().split('T')[0]}.xlsx`

      // 导出Excel文件
      XLSX.writeFile(wb, fileName)

      this.$message({
        message: '导出成功',
        type: 'success'
      })
    },
  },
}
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}
</style>
